// ============================================================
// GALERIA — filtro por categoria + ampliação da foto
// O mosaico é feito em colunas pelo CSS; aqui só escondemos os
// itens de fora do filtro e ajustamos as opções do Fancybox.
// ============================================================

(function () {
    'use strict';

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', iniciar);
    } else {
        iniciar();
    }

    function iniciar() {
        filtros();
        ampliacao();
    }

    function filtros() {
        var barra = document.querySelector('[data-gallery-filters]');
        var grade = document.querySelector('[data-gallery-grid]');
        if (!barra || !grade) return;

        var botoes = Array.prototype.slice.call(barra.querySelectorAll('[data-filter]'));
        var itens  = Array.prototype.slice.call(grade.querySelectorAll('.card-gallery'));

        botoes.forEach(function (botao) {
            botao.addEventListener('click', function () {
                var alvo = botao.getAttribute('data-filter');

                botoes.forEach(function (b) { b.classList.toggle('is-active', b === botao); });

                itens.forEach(function (item) {
                    item.hidden = !(alvo === '*' || item.getAttribute('data-cat') === alvo);
                });
            });
        });

        selecaoEstreita(barra, botoes);
    }

    // Em tela estreita a fileira de etiquetas não cabe — o SCSS esconde os
    // botões e mostra este <select>, gerado ao lado da barra. Mesmo padrão
    // do 15.filter-select.js do Goiatuba, adaptado: lá os filtros são links
    // que recarregam a página, aqui são botões que filtram no cliente,
    // então o select apenas dispara o clique do botão correspondente.
    function selecaoEstreita(barra, botoes) {
        if (!botoes.length) return;
        if (barra.parentNode.querySelector('.sec-gallery__filters-select')) return;

        var selecao = document.createElement('select');
        selecao.className = 'sec-gallery__filters-select';
        selecao.setAttribute('aria-label', barra.getAttribute('aria-label') || 'Filtrar');

        botoes.forEach(function (botao, i) {
            var opcao = document.createElement('option');
            opcao.value = String(i);
            opcao.textContent = botao.textContent.trim();
            if (botao.classList.contains('is-active')) opcao.selected = true;
            selecao.appendChild(opcao);
        });

        selecao.addEventListener('change', function () {
            var escolhido = botoes[Number(selecao.value)];
            if (escolhido) escolhido.click();
        });

        // Clicar numa etiqueta mantém o select em sincronia — os dois
        // coexistem no DOM, só a visibilidade muda por breakpoint.
        botoes.forEach(function (botao, i) {
            botao.addEventListener('click', function () { selecao.value = String(i); });
        });

        barra.parentNode.insertBefore(selecao, barra.nextSibling);
    }

    function ampliacao() {
        if (typeof jQuery === 'undefined') return;
        if (typeof jQuery.fn.fancybox === 'undefined') return;
        if (!document.querySelector('[data-fancybox]')) return;

        // O Fancybox liga sozinho nos elementos com [data-fancybox], então aqui
        // só ajustamos as opções padrão. O vídeo tem chamada própria em
        // 08.fancybox-video.js e passa as opções dele, que vencem estas.
        jQuery.fancybox.defaults.buttons = ['close'];
        jQuery.fancybox.defaults.loop = true;
        jQuery.fancybox.defaults.animationEffect = 'fade';
        jQuery.fancybox.defaults.transitionEffect = 'fade';
    }
})();
